import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    totalAmtShow: true,
    RBF0404A40Date: {}, //일별 거래내역조회 결과 초기화

    calendarInq: {
      acno: "", //계좌번호
      tranStartYmd: "", //거래시작일
      tranEndYmd: "", //거래종료일
      brncoInotDstcd: "00", //입출금구분 00:전체 10:입금
      resultSeq: "01", //결과순서
      dmndPageNo: 0, //요청페이지번호
      pageLineCnt: "1000", //페이지라인
    },
  };
};

const calendarInq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default calendarInq;
